import {
  toWSDateString,
  WSSelectOption
} from "@wingspanhq/fe-component-library";
import { PayPeriod } from "@wingspanhq/wingspan-api-sdk";
import orderBy from "lodash/orderBy";

/**
 * Pay periods as picker options, most recent first — the order a payer reads
 * them in, since the current and previous periods are the ones being worked on.
 *
 * A period with no id or no dates cannot be selected or labelled, so it is
 * dropped rather than rendered as a blank row.
 */
export const selectorPayPeriodOptions = (
  payPeriods: PayPeriod[]
): WSSelectOption[] =>
  orderBy(
    payPeriods.filter(
      payPeriod =>
        !!payPeriod.id && !!payPeriod.startDate && !!payPeriod.endDate
    ),
    payPeriod => payPeriod.startDate,
    "desc"
  ).map(payPeriod => ({
    value: payPeriod.id as string,
    label: `${toWSDateString(
      payPeriod.startDate,
      "monthDayYear"
    )} - ${toWSDateString(payPeriod.endDate, "monthDayYear")}`
  }));
